import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EmpresaGestora, EmpresaGestoraFiltro } from "../../types/EmpresaGestora";
import { Instalacion } from "../../types/Instalacion";
import { TrabajoEmpresa } from "../../types/TrabajoEmpresa";


interface EmpresaGestoraState {
    empresaGestoraList: EmpresaGestora[];
    instalacionList: Instalacion[];
    tiposTrabajoList: TrabajoEmpresa[];
    empresaGestoraSelected: EmpresaGestora;
    filtro: EmpresaGestoraFiltro;
    loading: boolean;
    errors: any;
    error: boolean,
    guardado: boolean,
}

export const empresaGestoraInitial: EmpresaGestora = {
    id: 0,
    nombreEmpresa: "",
    direccion: "",
    email: "",
    telefono: "",
    idTipoDocPersona: "",
    tipoDocumento: "",
    nroIdentificacion: "",
    activo: true,
    instalaciones: [],
    tiposTrabajo: [],
    logo: null,
    logoNuevo: null
}

export const empresaGestoraFiltroInitial: EmpresaGestoraFiltro = {
    idTipoDocPersona: "",
    nroIdentificacion: "",
    razonSocial: "",
    activo: null,
}

const initialState: EmpresaGestoraState = {
    empresaGestoraList: [],
    instalacionList: [],
    tiposTrabajoList: [],
    empresaGestoraSelected: empresaGestoraInitial,
    filtro: empresaGestoraFiltroInitial,
    loading: false,
    errors: [],
    error: false,
    guardado: false
}

const empresaGestoraSlice = createSlice({
    name: 'empresaGestora',
    initialState,
    reducers: {
        addEmpresaGestora: (state, data: PayloadAction<EmpresaGestora>): void => {
            state.empresaGestoraSelected = empresaGestoraInitial;
            state.error = false;
            state.guardado = true;
        },
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadDataEmpresaGestora: (state, data: PayloadAction<EmpresaGestora>): void => {
            state.empresaGestoraSelected = data.payload;
            state.error = false;
        },
        loadListEmpresaGestora: (state, data: PayloadAction<EmpresaGestora[]>): void => {
            state.empresaGestoraList = data.payload;
        },
        loadListInstalacion: (state, data: PayloadAction<Instalacion[]>): void => {
            state.instalacionList = data.payload;
        },
        loadListTiposTrabajo: (state, data: PayloadAction<TrabajoEmpresa[]>): void => {
            state.tiposTrabajoList = data.payload;
        },
        loadingError: (state, data: PayloadAction<any>): void => {
            state.errors = data.payload;
            state.error = true;
        },
        visibleError: (state, data: PayloadAction<boolean>): void => {
            state.error = data.payload;
        },
        removeEmpresaGestora: (state, data: PayloadAction<number>): void => {
            state.empresaGestoraList = state.empresaGestoraList.filter(p => p.id !== data.payload)
        },
        setGuardado: (state, data: PayloadAction<boolean>): void => {
            state.guardado = data.payload;
        },
        loadDataFiltro: (state, data: PayloadAction<EmpresaGestoraFiltro>): void => {
            state.filtro = data.payload;
        },
    }
});
export const {
    addEmpresaGestora,
    isLoading,
    loadDataEmpresaGestora,
    loadListEmpresaGestora,
    loadListInstalacion,
    loadListTiposTrabajo,
    loadingError,
    visibleError,
    removeEmpresaGestora,
    setGuardado,
    loadDataFiltro
} = empresaGestoraSlice.actions;

export default empresaGestoraSlice.reducer;
